import { apiList } from '../api/apiList'
import axiosInstance from '../api/axiosInstance'

const endpoint = apiList.logTrailApi

const logTrailService = {
  create: (payload) => axiosInstance.post(endpoint, payload),
  find: (query) => axiosInstance.get(`${endpoint}?${query}`),
}

export default logTrailService
